var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"queueNotification-page"}},[_c('h1',[_vm._v(_vm._s(_vm.userFirstName)+", por favor dirija-se ao:")]),_c('div',{staticClass:"serviceDesk__number"},[_c('span',[_vm._v("Guichê "+_vm._s(_vm.serviceDeskNumber))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }